export default __webpack_public_path__ + "static/media/grumpy-cat.730b0fe0.jpg";